<template>
  <div class="gycontainer">
    <div class="mkd333">
      <p class="fdsdfd">协会介绍</p>
      <div class="uwernb" v-html="neirong"></div>
      <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      neirong:'',
      fwcishu:0
    };
  },
  mounted() {
    this.queryGywm();
  },
  created() {
    this.tongji('协会介绍');
  },
  methods: {
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    queryGywm(){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/gywm/tGywm/list?_t='+new Date().getTime()+'&column=id&order=asc&field=id,conten,action&pageNo='+0+'&pageSize='+1)
          .then(function (response) {
            if (response.data.code == 200) {
              that.neirong  = response.data.result.records[0]['conten'];
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    }
  }
};
</script>


<style scoped>
.gycontainer{
  width: 100%;
  background-image:  url('../../assets/xxkc/gywm.png');
  display: flex;
  background-position: center;
  align-items: center;
  justify-content: center;
  background-size: 100%;
}
.mkd333{
  width: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  justify-content: center;
}
.fdsdfd{
  font-size: 32px;
  letter-spacing: 4px;
  color: black;
}
.uwernb{
  font-size: 16px;
  letter-spacing: 4px;
  line-height: 40px;
  color: black;
}
</style>
